import { Link as RouterLink } from "react-router-dom";
import FinanceAiVisual from "./FinanceAiVisual";

const ACCENT = "#4ADF83";

export default function LandingPage() {
  return (
    <div style={{
      background: "#ffffff",
      minHeight: "100vh",
      color: "#0B2818",
      fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
      overflowX: "hidden",
      display: "flex",
      flexDirection: "column",
    }}>

      {/* NAV */}
      <nav style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        height: 56,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 2rem",
      }}>
        <RouterLink to="/minipay" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
          <img src="/static/images/logo/logoyouon.svg" alt="Youon" style={{ height: 26 }} />
        </RouterLink>

        <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
          <RouterLink
            to="/minipay/login"
            style={{
              color: "rgba(11,40,24,0.75)",
              textDecoration: "none",
              fontSize: "0.875rem",
              fontWeight: 400,
              padding: "0.4rem 0.9rem",
              borderRadius: 8,
              letterSpacing: "0.01em",
            }}
          >
            Entrar
          </RouterLink>
          <RouterLink
            to="/minipay/register"
            style={{
              color: "#0B2818",
              textDecoration: "none",
              fontSize: "0.875rem",
              fontWeight: 400,
              padding: "0.4rem 1rem",
              borderRadius: 9999,
              border: "1px solid rgba(11,40,24,0.35)",
              letterSpacing: "0.01em",
              transition: "border-color 0.15s",
            }}
          >
            Cadastrar
          </RouterLink>
        </div>
      </nav>

      {/* HERO */}
      <section style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "clamp(2rem, 6vw, 5rem)",
        flexWrap: "wrap",
        paddingTop: "clamp(120px, 22vh, 200px)",
        paddingBottom: "10rem",
        paddingLeft: "clamp(1.5rem, 8vw, 9rem)",
        paddingRight: "clamp(1.5rem, 8vw, 9rem)",
      }}>
        <div style={{ maxWidth: 760 }}>
          <h1 style={{
            fontSize: "clamp(2.4rem, 5.5vw, 4.4rem)",
            fontWeight: 700,
            lineHeight: 1.12,
            letterSpacing: "-0.03em",
            margin: "0 0 1.5rem",
            color: "#0B2818",
          }}>
            Um sistema financeiro para grupos de WhatsApp, gerenciado por IA
          </h1>

          <p style={{
            fontSize: "clamp(1rem, 1.5vw, 1.2rem)",
            color: "rgba(11,40,24,0.45)",
            maxWidth: 480,
            margin: "0 0 2.5rem",
            lineHeight: 1.65,
            fontWeight: 400,
            letterSpacing: "0.01em",
          }}>
            Cadastre participantes, registre pagamentos e organize rateios do seu grupo — tudo por texto, foto ou lista, direto pro assistente de IA.
          </p>

          <div style={{ display: "flex", alignItems: "center", gap: "1.5rem", flexWrap: "wrap" }}>
            <RouterLink
              to="/minipay/register"
              style={{
                background: ACCENT,
                color: "#0a0a0a",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "0.9rem",
                padding: "0.6rem 1.4rem",
                borderRadius: 8,
                letterSpacing: "0.01em",
              }}
            >
              Começar grátis
            </RouterLink>
            <RouterLink
              to="/minipay/login"
              style={{
                color: "rgba(11,40,24,0.5)",
                textDecoration: "none",
                fontSize: "0.875rem",
                fontWeight: 400,
                letterSpacing: "0.01em",
                display: "flex",
                alignItems: "center",
                gap: "0.3rem",
              }}
            >
              Já tenho conta <span style={{ fontSize: "1rem" }}>→</span>
            </RouterLink>
          </div>
        </div>

        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}>
          <FinanceAiVisual size={480} />
        </div>
      </section>

    </div>
  );
}
